import React, { useState, useEffect, useRef } from "react";
import PageHeader from "../../components/PageHeader";
import {
  Typography,
  Container,
  TextField,
  InputAdornment,
} from "@mui/material";
import "./Chat.css";
import Conversation from "./components/Conversation";
import ChatBox from "../../components/ChatBox/ChatBox";
import { userChats, getUserById } from "../../apis";
import { io } from "socket.io-client";
import Navbar from "../../components/Navbar";
import SearchIcon from "@mui/icons-material/Search";

const Chat = () => {
  const socket = useRef();
  const [chats, setChats] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [sendMessage, setSendMessage] = useState(null);
  const [receivedMessage, setReceivedMessage] = useState(null);
  const [filteredChats, setFilteredChats] = useState([]);
  const [search, setSearch] = useState("");

  const user = JSON.parse(localStorage.getItem("user-info"));
  const userid = user.googleId ? user.googleId : user._id;
  useEffect(() => {
    const getChats = async () => {
      try {
        const { data } = await userChats(userid);
        let arr = [];
        await Promise.all(
          data.map(async (item) => {
            const chatUserId = item.members.find((id) => id !== userid);
            const { data } = await getUserById(chatUserId);
            arr.push({ conv: item, name: data.user.fullName });
          })
        );
        setChats(arr);
        setFilteredChats(arr);
      } catch (error) {
        console.log(error);
      }
    };
    getChats();
  }, []);

  // Connect to Socket.io
  useEffect(() => {
    socket.current = io("https://ammanat-chat-socket.herokuapp.com");
    socket.current.emit("new-user-add", userid);
    socket.current.on("get-users", (users) => {
      setOnlineUsers(users);
    });
  }, []);

  // Send Message to socket server
  useEffect(() => {
    if (sendMessage !== null) {
      console.log("send socket", sendMessage);
      socket.current = io("https://ammanat-chat-socket.herokuapp.com");
      socket.current.emit("send-message", sendMessage);
    }
  }, [sendMessage]);

  // Get the message from socket server
  useEffect(() => {
    socket.current = io("https://ammanat-chat-socket.herokuapp.com");
    socket.current.on("recieve-message", (data) => {
      console.log(data);
      setReceivedMessage(data);
    });
  }, []);

  const checkOnlineStatus = (chat) => {
    const chatMember = chat.members.find((member) => member !== userid);
    const online = onlineUsers.find((user) => user.userId === chatMember);
    return online ? true : false;
  };

  const chatDeleteHandler = async () => {
    // const { data } = await userChats(userid);
    // setCurrentChat(null);
    // setChats(data);
    window.location.reload();
  };

  const searchChangeHandler = (e) => {
    setSearch(e.target.value);
    let arr = [...chats];
    if (e.target.value == "") {
      setFilteredChats(arr);
    } else {
      const filteredarray = arr.filter((x) =>
        x["name"].includes(e.target.value)
      );
      console.log("filtered array ====>", filteredarray);
      setFilteredChats(filteredarray);
    }
    // arr.filter(x=>)
  };
  return (
    <>
      <Navbar />
      {/* <PageHeader crossIcon title="Chat" /> */}
      <div className="Chat">
        {/* left side chat */}
        <div className="Left-side-chat">
          <div className="Chat-container">
            <Typography
              style={{ fontWeight: "bold", marginLeft: "15px" }}
              className="mb-10"
            >
              Messages
            </Typography>
            <TextField
              size="small"
              variant="outlined"
              className="w-100 mb-16"
              placeholder="Search"
              value={search}
              onChange={(e) => searchChangeHandler(e)}
              // type="number"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <div className="Chat-list">
              {filteredChats.map((chat) => (
                <div
                  onClick={() => {
                    setCurrentChat(chat.conv);
                  }}
                >
                  <Conversation
                    data={chat.conv}
                    name={chat.name}
                    currentUser={userid}
                    online={checkOnlineStatus(chat.conv)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Side */}

        <div className="Right-side-chat">
          <ChatBox
            chat={currentChat}
            currentUser={userid}
            setSendMessage={(obj) => setSendMessage(obj)}
            receivedMessage={receivedMessage}
            deleteChatButton={chatDeleteHandler}
          />
        </div>
      </div>
    </>
  );
};

export default Chat;
